import script from "./CatalogueView.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogueView.vue?vue&type=script&setup=true&lang=js"

import "./CatalogueView.vue?vue&type=style&index=0&id=0f112509&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f112509"]])

export default __exports__